(function () {
  'use strict';

  var DEFAULT_CUT_H = 14;
  var DEFAULT_CUT_M = 30;
  var DEFAULT_TZ = 'America/Phoenix';
  var DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var SHIP_COUNTDOWN_SELECTOR = '[data-dd-ship-countdown], [data-dd-sf-ship-instock-text]';

  function readCutoffFromRoot(root, cfg) {
    if (!root) return cfg;
    var h = parseInt(root.getAttribute('data-cutoff-hour'), 10);
    if (!isNaN(h)) cfg.cutoffHour = h;
    var m = parseInt(root.getAttribute('data-cutoff-minute'), 10);
    if (!isNaN(m)) cfg.cutoffMinute = m;
    var t = root.getAttribute('data-cutoff-tz');
    if (t) cfg.tz = t;
    return cfg;
  }

  function getCutoffConfig() {
    var cfg = { cutoffHour: DEFAULT_CUT_H, cutoffMinute: DEFAULT_CUT_M, tz: DEFAULT_TZ };
    var root =
      document.querySelector('[data-dd-cart-items][data-cutoff-hour]') ||
      document.querySelector('#main-cart-items[data-cutoff-hour]') ||
      document.querySelector('[data-dd-trust-shipping][data-cutoff-hour]') ||
      document.querySelector('[data-dd-sf-ship][data-cutoff-hour]') ||
      document.querySelector('[data-dd-cart-items]') ||
      document.getElementById('main-cart-items');
    return readCutoffFromRoot(root, cfg);
  }

  function tzCalendarDate(date, tz) {
    try {
      var formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: tz,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      });
      var parts = {};
      var formatted = formatter.formatToParts(date);
      for (var i = 0; i < formatted.length; i++) {
        parts[formatted[i].type] = formatted[i].value;
      }
      return new Date(
        parseInt(parts.year, 10),
        parseInt(parts.month, 10) - 1,
        parseInt(parts.day, 10)
      );
    } catch (err) {
      return null;
    }
  }

  function getMsUntilNextCutoff(cutoffHour, cutoffMinute, tz) {
    var cal = window.DDShippingCalendar;
    if (cal && typeof cal.getMsUntilNextCutoff === 'function') {
      return cal.getMsUntilNextCutoff(cutoffHour, cutoffMinute, tz);
    }
    return NaN;
  }

  function nextCutoffShipDate(cutoffHour, cutoffMinute, tz) {
    var ms = getMsUntilNextCutoff(cutoffHour, cutoffMinute, tz);
    if (isNaN(ms) || ms < 0) return null;
    return tzCalendarDate(new Date(Date.now() + ms), tz);
  }

  function sameCalendarDay(a, b) {
    return (
      a &&
      b &&
      a.getFullYear() === b.getFullYear() &&
      a.getMonth() === b.getMonth() &&
      a.getDate() === b.getDate()
    );
  }

  function shipPillInfo(shipDate, today) {
    if (!shipDate || !today) {
      return { label: 'Ships soon', tier: 'later' };
    }
    if (sameCalendarDay(shipDate, today)) {
      return { label: 'Ships today', tier: 'today' };
    }
    var tomorrow = new Date(today.getTime());
    tomorrow.setDate(tomorrow.getDate() + 1);
    if (sameCalendarDay(shipDate, tomorrow)) {
      return { label: 'Ships tomorrow', tier: 'tomorrow' };
    }
    if (shipDate.getDay() === 1) {
      return { label: 'Ships Monday', tier: 'monday' };
    }
    return { label: 'Ships ' + DAY_NAMES[shipDate.getDay()], tier: 'later' };
  }

  function getPillInfo(cfg) {
    cfg = cfg || getCutoffConfig();
    var today = tzCalendarDate(new Date(), cfg.tz);
    var shipDate = nextCutoffShipDate(cfg.cutoffHour, cfg.cutoffMinute, cfg.tz);
    return shipPillInfo(shipDate, today);
  }

  function applyLabel(el, info) {
    if (!el || el.hasAttribute('data-dd-preorder-ship')) return;
    if (el.closest && el.closest('[data-dd-preorder-ship]')) return;
    /* Write only on change. An unconditional write replaces the text
       node, which the product-info MutationObserver below sees as a
       childList mutation -> scheduleUpdate -> another write: a 60fps
       loop that also fed dd-sticky-footer's own product-info observer
       every frame and starved its rAF-debounced fit passes. */
    if (el.textContent !== info.label) el.textContent = info.label;
  }

  function paintInstockText(txtEl) {
    if (!txtEl) return;
    var lead = txtEl.querySelector('[data-dd-sf-ship-instock-lead]');
    var count = txtEl.querySelector('[data-dd-ship-countdown]');
    if (!lead || !count) {
      txtEl.textContent = '';
      lead = document.createElement('span');
      lead.setAttribute('data-dd-sf-ship-instock-lead', '');
      lead.textContent = 'In stock. ';
      count = document.createElement('span');
      count.setAttribute('data-dd-ship-countdown', '');
      txtEl.appendChild(lead);
      txtEl.appendChild(count);
    } else if (lead.textContent !== 'In stock. ') {
      lead.textContent = 'In stock. ';
    }
    applyLabel(count, getPillInfo());
  }

  function paintLowstockText(txtEl, qty) {
    if (!txtEl) return;
    var n = String(qty);
    var leadText = 'Hurry ' + n + ' left. ';
    var lead = txtEl.querySelector('[data-dd-sf-ship-lowstock-lead]');
    var pill = txtEl.querySelector('[data-dd-ship-countdown]');
    var qtyEl = txtEl.querySelector('[data-dd-sf-lowstock-count]');
    if (qtyEl && pill) {
      if (qtyEl.textContent !== n) qtyEl.textContent = n;
      applyLabel(pill, getPillInfo());
      return;
    }
    if (lead && pill) {
      if (lead.textContent !== leadText) lead.textContent = leadText;
      applyLabel(pill, getPillInfo());
      return;
    }
    txtEl.textContent = '';
    lead = document.createElement('span');
    lead.setAttribute('data-dd-sf-ship-lowstock-lead', '');
    lead.textContent = leadText;
    pill = document.createElement('span');
    pill.setAttribute('data-dd-ship-countdown', '');
    txtEl.appendChild(lead);
    txtEl.appendChild(pill);
    applyLabel(pill, getPillInfo());
  }

  function paintPdpStockText(txtEl, kind, opts) {
    if (!txtEl) return;
    opts = opts || {};
    if (kind === 'instock') {
      paintInstockText(txtEl);
      return;
    }
    if (kind === 'lowstock') {
      paintLowstockText(txtEl, opts.count);
      return;
    }
    var text = '';
    if (kind === 'digital') text = 'Instantly available';
    else if (kind === 'event') text = opts.label || 'Tickets available';
    else if (kind === 'preorder') text = opts.note || 'Estimated to ship. Subject to delays.';
    else if (kind === 'custom') text = 'Made to order. 6-8 weeks';
    else if (kind === 'soldout') text = opts.label || 'Sold out';
    else text = opts.label || '';
    if (text) txtEl.textContent = text;
  }

  function update() {
    var els = document.querySelectorAll(SHIP_COUNTDOWN_SELECTOR);
    if (!els.length) return;
    var info = getPillInfo();
    for (var i = 0; i < els.length; i++) applyLabel(els[i], info);
  }

  window.DDShipCountdown = {
    getCutoffConfig: getCutoffConfig,
    getPillInfo: getPillInfo,
    applyLabel: applyLabel,
    paintInstockText: paintInstockText,
    paintLowstockText: paintLowstockText,
    paintPdpStockText: paintPdpStockText,
    update: update,
    selector: SHIP_COUNTDOWN_SELECTOR,
  };
  window.__ddShipCountdownUpdate = update;

  if (window.__ddShipCountdown) {
    update();
    return;
  }
  window.__ddShipCountdown = true;

  update();
  setInterval(update, 60000);

  var _rafScheduled = false;
  function scheduleUpdate() {
    if (_rafScheduled) return;
    _rafScheduled = true;
    requestAnimationFrame(function () {
      _rafScheduled = false;
      update();
    });
  }

  var roots = [
    document.querySelector('cart-drawer'),
    document.getElementById('main-cart-items'),
    document.querySelector('dd-sticky-footer'),
    document.querySelector('product-info'),
  ];
  for (var i = 0; i < roots.length; i++) {
    if (roots[i] && window.MutationObserver) {
      new MutationObserver(scheduleUpdate).observe(roots[i], { childList: true, subtree: true });
    }
  }

  document.addEventListener('drawer:opened', scheduleUpdate);
  document.addEventListener('cart:updated', scheduleUpdate);
})();
